import React, { createContext, useContext } from 'react';
import { StrapiSourceData } from "../interfaces/strapi";

const defaultContextValue: StrapiSourceData = {
  event: {
    url: "",
    email: "",
    emailSubject: "",
    siteUrl: "",
    favicon: { url: "" },
    twitterWallSlug: "",
    twitterWallProvider: "everwall",
    twitterImage: { url: "" },
    twitterUsername: "",
    defaultDescription: "",
    defaultTitle: "Loading Event...",
    defaultImage: { url: "" },
    description: "",
    virtualDescription: "",
    privacyText: "",
    privacyLink: "",
    sponsorText: "",
    sponsorButtonText: "",
    levels: [],
    eventId: "",
    hashtag: "",
    singlePage: false,
    siteName: "Event Placeholder",
    title: "Loading Event...",
    starts: "",
    ends: "",
    virtualStart: "",
    virtualEnd: "",
    timezone: "",
    facebookImage: { url: "" },
    startDate: "",
    endDate: "",
    producer: "",
    producerSite: "",
    externalRegistrationEmbedId: "",
    externalRegistrationVirtualEmbedId: "",
    externalEventPlatform: "",
    addresses: [{
      location: "",
      postalCode: "",
      addressRegion: "",
      addressCountry: "",
      streetAddress: "",
      addressLocality: "",
      embed: { data: { embed: "" } }
    }]
  },
  sessions: [],
  speakers: [],
  sponsors: [],
  brightcove: {
    playlistId: "",
    accountId: "",
    playerId: "",
    liveMainVideoId: "",
    liveDVRVideoId: "",
    liveSessionPlaylistId: "",
    preEventPlaceholder: "",
    defaultPlaceholder: "",
    postEventPlaceholder: "",
    mainVideoActiveTime: ""
  },
  addresses: [
    {
      venueName: "",
    }
  ],
  ticket_types: [],
  virtual: false,
};

function addPrefixToUrls<T extends StrapiSourceData>(obj: T, keysToPrefix: string[], prefix: string): T {
  if (Array.isArray(obj)) {
    return obj.map(item => {
      if (typeof item === 'object' && item !== null) {
        return addPrefixToUrls(item as unknown as T, keysToPrefix, prefix);
      } else {
        return item;
      }
    }) as unknown as T;
  }

  return Object.keys(obj).reduce((acc, key) => {
    const value = obj[key as keyof T];

    if (keysToPrefix.includes(key) && typeof value === 'string') {
      // Don't prefix if it's already a full URL
      if (!/^https?:\/\//.test(value)) {
        acc[key as keyof T] = `${prefix}${value}` as typeof value;
      } else {
        acc[key as keyof T] = value;
      }
    } else if (typeof value === 'object' && value !== null) {
      acc[key as keyof T] = addPrefixToUrls(value as unknown as T, keysToPrefix, prefix) as typeof value;
    } else {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as T);
}

const EventContext = createContext<StrapiSourceData>(defaultContextValue);

export const useEventContext = () => useContext(EventContext);
interface EventProviderProps {
  children: React.ReactNode;
  data: StrapiSourceData;
}

export const EventProvider = ({ children, data }: EventProviderProps) => {

  const keysToPrefix = ['url'];
  const cmsPrefix = process.env.STRAPI_API_URL || 'http://localhost:1337';
  // In production we are using URLs that are for assets on the CDN
  const addPrefix = process.env.NODE_ENV !== 'production';
  const updatedData = addPrefix ? addPrefixToUrls(data, keysToPrefix, cmsPrefix) : data;

  return (
    <EventContext.Provider value={updatedData}>
      {children}
    </EventContext.Provider>
  );
};
